import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { cn } from "@/libs/utils";
import { Button2 } from "@/components/webview/games/typograpy/typograpy-webview";

type ButtonWidthChildrenProps = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement>
>;

export const GamesButtonWebView = ({
  className,
  children,
  type = "button",
  ...props
}: ButtonWidthChildrenProps) => {
  return (
    <button
      type={type}
      {...props}
      className={cn(
        "h-[40px] w-full rounded-md bg-[#FFD900] text-black",
        className,
      )}
    >
      <Button2>{children}</Button2>
    </button>
  );
};

export const GamesSearchButtonWebView = ({
  className,
  children,
  ...props
}: ButtonWidthChildrenProps) => {
  return (
    <button
      type="button"
      className={cn(
        "flex h-[32px] items-center rounded-md border border-[#3F3F3F] px-3 text-sm font-400 text-white",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
